import { Base } from '@studiometa/js-toolkit';

/**
 * Login component
 */
export default class Login extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Login',
    refs: ['forgetPasswordLink', 'loginForm', 'resetForm', 'linkBack'],
  };

  /**
   * On click
   */
  onForgetPasswordLinkClick() {
    this.$refs.loginForm.classList.add('hidden');
    this.$refs.resetForm.classList.remove('hidden');
    this.hideMessage();
  }

  /**
   *
   */
  onLinkBackClick() {
    this.$refs.resetForm.classList.add('hidden');
    this.$refs.loginForm.classList.remove('hidden');
    this.hideMessage();
  }

  /**
   *
   */
  hideMessage() {
    const successMessage = document.querySelector('.form__message');
    if (successMessage) {
      successMessage.classList.add('hidden');
    }
  }
}
